import { Box } from '@mui/material';
import { motion } from 'framer-motion';

const AnimatedTick: React.FC<{ size?: number }> = ({ size = 18 }) => (
  <Box
    component={motion.svg}
    sx={{ display: 'block' }}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.2, ease: 'easeOut' }}
    aria-hidden
  >
    <motion.circle
      cx="12"
      cy="12"
      r="9"
      fill="transparent"
      stroke="#22c55e"
      strokeWidth="2"
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: 0.6, ease: 'easeInOut' }}
    />
    <motion.path
      d="M8 12.5l2.5 2.5L16 9"
      fill="transparent"
      stroke="#22c55e"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: 0.6, ease: 'easeInOut', delay: 0.1 }}
    />
  </Box>
);

export default AnimatedTick;
